import { useState } from 'react';
import Input from '../../../../components/Inputs/Input';
import './NlaPositions.css';

export const NlaPositions = ({ partNumber, positions, updatePositions, editing, onClose }) => {

    return (
        <div className='nla-positions-component' onClick={(e) => e.stopPropagation()}>
            {/* {JSON.stringify(positions)} */}
            <div className='nla-positions-header'>
                <div className='left'>

                    <b>NLA Positions</b>
                    <span>PN</span>
                    <b>{partNumber}</b>
                </div>
                <div className='right'>
                    {editing && <button className='filled mid-size' onClick={onClose}> OK </button>}
                    <button className='outlined mid-size icon small-size' onClick={onClose}><i className='icon-cross'></i> </button>
                </div>
            </div>
            <div className='nla-positions-list'>
                {positions.map((i, j) => <div key={j} className='nla-pos-item'>
                    { }
                    <span>Position {j + 1}</span>
                    <div className='input-container'>
                        <span>NLA Position</span>
                        {editing ? <Input value={i.position} onChange={(e) => updatePositions(prev => {
                            let copy = [...prev];
                            copy[j] = {...copy[j], position:e.target.value};
                            return copy
                        })} /> :
                            <b>{i.position}</b>}
                    </div>
                </div>)}
            </div>
        </div>
    )
}